import React, { ChangeEventHandler } from 'react';
import { ButtonRowView } from '../../Buttons/ButtonRowView';

type TSelectPhotosProps = {
    label?: string;
    iconName?: string;
    handleChange: ChangeEventHandler;
};
const SelectPhotos = ({ label, iconName, handleChange }: TSelectPhotosProps) => {
    return (
        <label htmlFor="file">
            <ButtonRowView as="div" label={label} iconName={iconName} />
            <input
                id="file"
                type="file"
                accept=".png,.jpg,.gif,.webp,image/jpeg,image/gif,image/webp,image/png"
                onChange={handleChange}
                style={{ display: 'none' }}
            />
        </label>
    );
};
export { SelectPhotos };
